import script from "./MainVerifyAccountComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainVerifyAccountComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainVerifyAccountComponent.vue?vue&type=style&index=0&id=45aeed01&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45aeed01"]])

export default __exports__